export default __webpack_public_path__ + "static/media/WebMD.4c0b77df.svg";